module.exports = __webpack_public_path__ + "static/media/loader-car.ee0c2744.gif";